<template>
  <div class="form__container">
    <div class="form__container__content">
      <div class="status__header">
        <Label
          class="mt-3"
          :value="Number(total)"
          colored
          success
          icon
        />

        <h2 class="status__header__title">
          {{ title | capitalizeFirstLetter }}
        </h2>

        <p class="status__header__disclaimer">
          <span v-if="kind === 'employee'" v-html="$t(`${namespace}.textEmployees`)" />
          <span v-if="kind === 'costCenter'" v-html="$t(`${namespace}.textCostCenter`)" />
          <span v-if="kind === 'project'" v-html="$t(`${namespace}.textProjects`)" />
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Label from 'components/bulkImport/Label'

export default {
  name: 'StepThree',
  props: {
    kind: {
      type: String
    },
    total: {
      type: [Number, String],
      default: 0
    }
  },
  components: {
    Label
  },
  computed: {
    type () {
      if (this.kind === 'costCenter') {
        return this.$t('Common.costCenters')
      }

      if (this.kind === 'employee') {
        return this.$t('Common.employees')
      }

      if (this.kind === 'project') {
        return this.$t('Common.projects')
      }

      if (this.kind === 'incentives') {
        return this.$t('Common.incentives')
      }

      if (this.kind === 'approvePayment') {
        return this.$t('Common.charges')
      }

      return ''
    },

    title () {
      return this.$t(`${this.namespace}.title`).replace('[TYPE]', this.type.toLowerCase())
    }
  },
  data () {
    return {
      namespace: 'Views.BulkImportPage.finalStep'
    }
  }
}
</script>

<style lang="scss" scoped>
.status__header {
  text-align: center;
}

.status__header__title {
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-weight: 700;
  margin: 24px 0;
}

.status__header__disclaimer {
  color: $gray-6;
  margin: 32px 0 16px;
}
</style>
